var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import DayPicker from 'react-day-picker';
import T from '../Utils/Locale';
const ComponentDayPicker = (_a) => {
    var { onDayClick } = _a, props = __rest(_a, ["onDayClick"]);
    return (_jsx(DayPicker, Object.assign({ months: [
            T('months.january'),
            T('months.february'),
            T('months.march'),
            T('months.april'),
            T('months.may'),
            T('months.june'),
            T('months.july'),
            T('months.august'),
            T('months.september'),
            T('months.october'),
            T('months.november'),
            T('months.december')
        ], weekdaysShort: [
            T('weekday.short.sunday'),
            T('weekday.short.monday'),
            T('weekday.short.tuesday'),
            T('weekday.short.wednesday'),
            T('weekday.short.thursday'),
            T('weekday.short.friday'),
            T('weekday.short.saturday')
        ] }, props, { onDayClick: handleClickDay })));
    function handleClickDay(date, event) {
        if (!event.disabled) {
            onDayClick(date);
        }
    }
};
ComponentDayPicker.propTypes = { onDayClick: PropTypes.func.isRequired };
export default ComponentDayPicker;
